import { render } from "./ServicesMonth.vue?vue&type=template&id=1fa2e98e"
import script from "./ServicesMonth.vue?vue&type=script&lang=js"
export * from "./ServicesMonth.vue?vue&type=script&lang=js"

import "./ServicesMonth.vue?vue&type=style&index=0&id=1fa2e98e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__